import { Check, Loader2 } from "lucide-react";
import { useBulkApproveMentorTraining } from "@/lib/api/training-simulator/training-simulator-review";

interface ReviewBatchApproveBarProps {
  progressIds: string[];
  onApproved: () => void;
}

export function ReviewBatchApproveBar({
  progressIds,
  onApproved,
}: ReviewBatchApproveBarProps) {
  const { mutate: bulkApprove, isPending } = useBulkApproveMentorTraining();

  if (progressIds.length === 0) return null;

  const handleApprove = () => {
    bulkApprove({ progressIds }, { onSuccess: () => onApproved() });
  };

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4">
      <div className="pointer-events-auto flex items-center gap-6 rounded-xl bg-brand-trueBlack py-4 pl-6 pr-3 shadow-lg">
        <span className="whitespace-nowrap text-body-2 font-medium text-brand-trueWhite">
          {progressIds.length} selected
        </span>
        <button
          type="button"
          onClick={handleApprove}
          disabled={isPending}
          className="flex h-8 items-center gap-2 rounded-xl bg-brand-trueWhite px-3 text-body-2 font-bold text-brand-trueBlack transition-opacity hover:opacity-90 disabled:opacity-60"
        >
          {isPending ? (
            <Loader2 className="size-4 animate-spin" />
          ) : (
            <Check className="size-4" />
          )}
          Approve
        </button>
      </div>
    </div>
  );
}
